import React, { useEffect, useState } from 'react';
import { getUserDetails } from '../api/userApi';
import { useNavigate } from 'react-router-dom';
import './ProfilePage.css';

export default function ProfilePage() {
  const [userDetails, setUserDetails] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchUser() {
      try {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
          const parsed = JSON.parse(storedUser);
          const userId = parsed.UserId || parsed.userId || parsed.id;
          if (userId) {
            const data = await getUserDetails(userId);
            setUserDetails(data || parsed);
          } else {
            setUserDetails(parsed);
          }
        }
      } catch (err) {
        const storedUser = localStorage.getItem('user');
        if (storedUser) setUserDetails(JSON.parse(storedUser));
      } finally {
        setLoading(false);
      }
    }
    fetchUser();
  }, []);

  const name = userDetails?.Name || userDetails?.name || userDetails?.userName || 'Customer';
  const email = userDetails?.Email || userDetails?.email || 'N/A';
  const phone = userDetails?.PhoneNumber || userDetails?.phoneNumber || userDetails?.phone || 'N/A';
  const city = userDetails?.City || userDetails?.city || 'Gujarat, India';

  return (
    <div className="profile-page-wrapper">
      <div className="profile-container">
        {/* Header */}
        <div className="profile-header">
          <button className="profile-back-btn" onClick={() => navigate(-1)}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
            </svg>
            <span>Back</span>
          </button>
          <h1 className="profile-title">My Account Profile</h1>
        </div>

        {loading ? (
          <div className="profile-loading">
            <div className="profile-spinner"></div>
            <p>Loading profile...</p>
          </div>
        ) : (
          <div className="profile-card-grid">
            {/* Main user info card */}
            <div className="profile-main-card">
              <div className="profile-avatar-wrap">
                <div className="profile-avatar-letter">
                  {name.charAt(0).toUpperCase()}
                </div>
                <div>
                  <h2 className="profile-user-name">{name}</h2>
                  <span className="profile-role-tag">Verified Customer</span>
                </div>
              </div>

              <div className="profile-details-list">
                <div className="profile-detail-item">
                  <span className="detail-label">Email Address</span>
                  <span className="detail-val">{email}</span>
                </div>

                <div className="profile-detail-item">
                  <span className="detail-label">Contact Number</span>
                  <span className="detail-val">{phone}</span>
                </div>

                <div className="profile-detail-item">
                  <span className="detail-label">Location</span>
                  <span className="detail-val">{city}</span>
                </div>
              </div>
            </div>

            {/* Quick shortcuts card */}
            <div className="profile-shortcuts-card">
              <h3 className="shortcuts-title">Quick Actions</h3>

              <div className="shortcuts-list">
                <button className="shortcut-btn" onClick={() => navigate('/my-orders')}>
                  <span className="shortcut-icon">📦</span>
                  <div className="shortcut-text">
                    <strong>My Orders</strong>
                    <span>Track current and past fireworks orders</span>
                  </div>
                  <span className="shortcut-arrow">&rarr;</span>
                </button>

                <button className="shortcut-btn" onClick={() => navigate('/category')}>
                  <span className="shortcut-icon">✨</span>
                  <div className="shortcut-text">
                    <strong>Shop Categories</strong>
                    <span>Browse all festive crackers & sky shots</span>
                  </div>
                  <span className="shortcut-arrow">&rarr;</span>
                </button>

                <a 
                  href="https://wa.me/917990696364" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="shortcut-btn"
                >
                  <span className="shortcut-icon">💬</span>
                  <div className="shortcut-text">
                    <strong>WhatsApp Help Desk</strong>
                    <span>Chat directly for order inquiries & support</span>
                  </div>
                  <span className="shortcut-arrow">&rarr;</span>
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}